const additionalCrashGames = [
  {
    name: 'Spaceman',
    value: '1301',
    type: 'crash-games',
    provider: 'pragmaticlive',
    routeProvider: 'pragmaticlive',
    isActive: false,
    position: 0,
    imgUrl: 'https://bsw-dk1.pragmaticplay.net/game_pic/square/200/1301.png',
    tab: ['crash'],
  },
  {
    name: 'Big Bass Crash',
    value: '1320',
    type: 'crash-games',
    provider: 'pragmaticlive',
    routeProvider: 'pragmaticlive',
    isActive: false,
    position: 0,
    imgUrl: 'https://bsw-dk1.pragmaticplay.net/game_pic/square/200/1320.png',
    tab: ['crash'],
  },
];

export default additionalCrashGames;
